import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import {ISetGoogleFontsStatePayload} from '../../../action/settings.action';
import {IGoogleFont} from '../../../interface/google-fonts.interface';

export const setGoogleFontsState = (fontsFamiliesString: string, fonts: IGoogleFont[]) =>
  returnAction<ISetGoogleFontsStatePayload>(ActionEnum.SET_GOOGLE_FONTS_STATE, {fontsFamiliesString, fonts});
